
export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="h-1 w-12 bg-gradient-to-r from-teal-600 to-emerald-600 rounded-full"></div>
                <span className="text-xs uppercase tracking-widest text-teal-600 font-semibold whitespace-nowrap">About Us</span>
              </div>
              <h2 className="text-5xl font-bold text-gray-900 leading-tight">
                Experts in iOS<br />Application Development
              </h2>
            </div>

            <p className="text-2xl text-gray-700 leading-relaxed">
              BOMAG d.o.o. is a dedicated team of professionals specializing in creating modern, innovative applications for the iOS platform. We combine technical expertise with creative design to deliver products that not only meet but exceed user expectations.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Our focus is on developing applications that enhance user experience and improve the security of mobile devices. With years of experience in iOS development, we understand the intricacies of the platform and leverage the latest technologies to create robust, scalable, and user-friendly applications.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-teal-100 to-emerald-100 rounded-3xl blur-2xl opacity-50"></div>
              <div className="relative bg-white rounded-3xl p-2 shadow-2xl border-8 border-white">
                <div className="w-full h-[500px] rounded-2xl overflow-hidden">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/1f37c01bb1a9066db8d26d0515de5198.jpg"
                    alt="BOMAG Team"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute top-8 right-8 bg-white px-4 py-2 rounded-full shadow-lg">
                  <span className="text-sm font-semibold text-teal-600 whitespace-nowrap">Ljubljana Based</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}